import { ReactElement, useMemo } from 'react'
import { filter } from 'lodash-es'
import { useResultsStore } from '@editorStores'
import { useResultsSelection } from '@editorHooks'

interface Props {
  loads: (DomainLoad | AreaLoad)[]
  component: (props: {
    isAnchorCalculationMode: boolean
    lineLoads: LineLoadWithDomain[]
    pointLoads: PointLoadWithDomain[]
    areaLoads: AreaLoad[]
    setHiddenLoads: (loads: string[]) => void
    hiddenLoads: string[]
  }) => ReactElement
}

const DatagridLoadWrapper = ({ component, loads }: Props): ReactElement => {
  const isAnchorCalculationMode = useResultsSelection().activeMode === 'tensile-connectors-table'
  const setHiddenLoads = useResultsStore(state => state.setHiddenLoads)
  const hiddenLoads = useResultsStore(state => state.hiddenLoads)

  const { lineLoads, pointLoads, areaLoads } = useMemo(
    () => ({
      lineLoads: loads && (filter(loads, ['load_type', 'line-load']) as LineLoadWithDomain[]),
      pointLoads: loads && (filter(loads, ['load_type', 'point-load']) as PointLoadWithDomain[]),
      areaLoads: loads && (filter(loads, ['load_type', 'area-load']) as AreaLoad[]),
    }),
    [loads],
  )

  return component({
    lineLoads,
    pointLoads,
    areaLoads,
    isAnchorCalculationMode,
    setHiddenLoads,
    hiddenLoads,
  })
}

export default DatagridLoadWrapper
